import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FilterNoneIcon from "@mui/icons-material/FilterNone";
import { Grid, Divider } from "@mui/material";
import Chip from "@mui/material/Chip";
import AcUnitIcon from "@mui/icons-material/AcUnit";

export default function CustomizedDialogs(props) {
  const { InstanceID } = props;

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    fetch(
      `${process.env.REACT_APP_API_URL}/api/manualactivelog/${InstanceID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setinstancelog(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const handleClose = () => {
    setOpen(false);
  };

  function DateTime1(startDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startDate1 = new Date(startDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const startDate2 = startDate1.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-");
    return startDate3;
  }

  function DateTime2(startDate, startTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startTime1 = new Date(
      startDate + "T" + startTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);
    return startTime3;
  }

  const [instancelog, setinstancelog] = React.useState([]);

  // React.useEffect(() => {
  //   fetch(
  //     `${process.env.REACT_APP_API_URL}/api/virtualizationactivelog/${InstanceID}`,
  //     {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: "Bearer " + localStorage.getItem("token"),
  //       },
  //     }
  //   )
  //     .then((resp) => resp.json())
  //     .then((data) => {
  //       if (data.detail) {
  //       } else {
  //         setinstancelog(data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // }, [InstanceID]);

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <IconButton aria-label="Filter" color="secondary">
          <FilterNoneIcon /> &nbsp;&nbsp;
          <span style={{ fontSize: "0.7em", color: "#172B4D" }}>Log</span>
        </IconButton>
      </MenuItem>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        scroll="paper"
        open={open}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          <Chip
            icon={<AcUnitIcon />}
            label="Active log"
            clickable
            color="primary"
          />
        </DialogTitle>
        <DialogContent dividers>
          <Grid container justifyContent="center">
            <Grid item>
              <Typography variant="subtitle1" color="textSecondary" gutterBottom>
                UTC time is displayed here.
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <Typography variant="h8">
                    <strong>Channel</strong>
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={2}>
                  <Typography variant="h8">
                    <strong>Status</strong>
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={2}>
                  <Typography variant="h8">
                    <strong>Date</strong>
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={2}>
                  <Typography variant="h8">
                    <strong>Time</strong>
                  </Typography>
                  <Divider />
                </Grid>
                
                <Grid item xs={4}>
                  <Typography variant="h8">
                    <strong>Executed by</strong>
                  </Typography>
                  <Divider />
                </Grid>
              </Grid>
            </Grid>

            {instancelog.map((actdata) => {
              return (
                <React.Fragment>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={2}>
                        <Typography variant="h8">{actdata.channel}</Typography>
                      </Grid>
                      <Grid item xs={2}>
                      <Typography variant="h8">{actdata.action}</Typography>
                        {/* {actdata.action === "created" ? (
                          <Typography variant="h8">Created</Typography>
                        ) : actdata.action === "started" ? (
                          <Typography variant="h8">Started</Typography>
                        ) : actdata.action === "stopped" ? (
                          <Typography variant="h8">Stopped</Typography>
                        ) : actdata.action === "scheduled" ? (
                          <Typography variant="h8">Scheduled</Typography>
                        ) : actdata.action === "terminated" ? (
                          <Typography variant="h8">Terminated</Typography>
                        ) : actdata.action === "uncordoned" ? (
                          <Typography variant="h8">UnCordoned</Typography>
                        ) : (
                          <Typography variant="h8"></Typography>
                        )} */}
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="h8">
                          {DateTime1(`${actdata.date}`)}
                        </Typography>
                      </Grid>
                      {actdata.time === "" ? (
                        <Grid item xs={2}>
                          <Typography variant="h8">NA</Typography>
                        </Grid>
                      ) : (
                        <Grid item xs={2}>
                          <Typography variant="h8">
                            {DateTime2(`${actdata.date}`, `${actdata.time}`)}
                          </Typography>
                        </Grid>
                      )}
                      
                      <Grid item xs={4}>
                        <Typography variant="h8">{actdata.email.split('@')[0]}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Divider />
                </React.Fragment>
              );
            })}
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}